export function getDate(): Date {
    return new Date();
}

export function getCurrentTime() : number {
    return getDate().getTime(); 
}

export function getDateFromString(dateString: string): Date {
    return new Date(dateString);
}

export function oneHourFromNow(): Date {
    var now = getDate();
    var time = getCurrentTime();
    var expireTime = time + 1000 * 60 * 60;
    now.setTime(expireTime);
    return now;
}

export function oneHourFromNowAsUtcString(): string {
    return oneHourFromNow().toUTCString();
}

export function getNiceFormatedDateTime(date: Date, language: string, text: string): String {
    return getNiceFormatedDate(date, language) + text + getNiceFormatedTime(date, language);
}

export function getNiceFormatedDate(date: Date, language: string): String {
    let dateOptions: Intl.DateTimeFormatOptions = {
        day: 'numeric', month: 'short'
    };

    return date.toLocaleDateString(language, dateOptions);
}

export function getNiceFormatedTime(date: Date, language: string): String {
    let timeOptions: Intl.DateTimeFormatOptions = {
        hour: '2-digit', minute: '2-digit'
    };

    return date.toLocaleTimeString(language, timeOptions).replace(':', '.');
}

export function getNiceFormatedWeekday(date: Date, language: string): String {
    let dateOptions: Intl.DateTimeFormatOptions = {
        weekday: 'long'
    };

    return date.toLocaleDateString(language, dateOptions);
}

export function getDaysDiffFromNow(date: Date) : number {
    return Math.floor( ( (Date.now() - Date.parse(date.toDateString())) / 1000 ) / 86400 );
}

